import { Field, FieldArray, Form, Formik } from "formik";
import { useState } from "react";
import { Button, Card, Col, Row, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";
import TextInput from "../../../../../components/formfields/InputField";
import { addHomeDataAction } from "../actions";
import { FeatureItemPropTypes } from "../types";
import AddFeatureModal from "./addFeatureModal";

const FeatureItem = ({ item, index, arrayHelpers, uploadAction, setFieldValue, edit, uploadNewAction }: FeatureItemPropTypes) => {
  const [showEditFeature, setShowEditFeature] = useState<boolean>(false);

  return (
    <tr>
      <td className="p-3" style={{ minWidth: "150px" }}>
        <div className="btn rounded btn-icon text-white d-inline-block mb-3" style={{ background: item.color }}>
          <img src={item.dummyImage || item.icon} alt="Icon" width="15px" height="15px" />
        </div>
        <p className="fw-bold mb-2">{item.title}</p>
        <p>{item.description}</p>
      </td>
      <td className="align-middle py-3 px-4">
        <video controls autoPlay src={item.video} style={{ maxWidth: "100px" }}></video>
      </td>
      <td className="align-middle p-3">
        <div className="d-flex flex-column align-items-center justify-content-center">
          <i
            className={`fa-light p-3 fa-trash-can ${edit && "cursor-pointer"}`}
            onClick={() => {
              edit && arrayHelpers.remove(index);
            }}
          ></i>
          <i className={`fa-light p-3 fa-pen-line ${edit && "cursor-pointer"}`} onClick={() => edit && setShowEditFeature(true)}></i>
          {showEditFeature && (
            <AddFeatureModal
              show={showEditFeature}
              setShow={setShowEditFeature}
              editData={item}
              customArrayHelper={arrayHelpers}
              uploadAction={uploadAction}
              setFieldValue={setFieldValue}
              index={index}
              uploadNewAction={uploadNewAction}
            />
          )}
        </div>
      </td>
    </tr>
  );
};

const gobalSchema = Yup.object({
  // who_title: Yup.string().required("Title can not be empty"),
  // global_description: Yup.string().required("Paragraph can not be empty"),
  // who_button_title: Yup.string().required("Button title can not be empty"),
  // global_features: Yup.array()
  //   .of(
  //     Yup.object().shape({
  //       title: Yup.string().required("title can not be empty"),
  //       color: Yup.string().required("color can not be empty"),
  //       video: Yup.string().required("video can not be empty"),
  //       bottom_text: Yup.string().required("animation text can not be empty"),
  //     })
  //   )
  //   .required("items can not be empty")
  //   .min(3, "please add minimum 3 items")
  //   .max(3, "you can add max 3 items"),
});

const GlobalFeaturesSection = ({ props }: any) => {
  const [whoEdit, setWhoEdit] = useState<boolean>(false);
  const [showAddFeature, setShowAddFeature] = useState<boolean>(false);

  const dispatch = useDispatch();
  const global_state = useSelector((state: any) => state?.home?.home_data);
  const globaState = {
    global_header: global_state?.global_header ? global_state?.global_header : "",
    global_description: global_state?.global_description ? global_state?.global_description : "",
    global_button: global_state?.global_button ? global_state?.global_button : "",
    global_button_link: global_state?.global_button_link ? global_state?.global_button_link : "",
    global_features: global_state?.global_features ? global_state?.global_features : [],
  };

  const handleGlobalSubmit = (values: any) => {
    if ((!values.global_button && values.global_button_link) || (values.global_button && !values.global_button_link)) {
      toast.error("Please validate the form");
    } else {
      let newArray = values?.global_features?.map((obj: any) => {
        const { dummyImage, oldImage, ...rest } = obj; // Using object destructuring to exclude the 'name' property
        return rest;
      });
      const form_data = new FormData();
      form_data.append("id", "global");
      form_data.append("global_header", values.global_header);
      form_data.append("global_description", values.global_description);
      form_data.append("global_button", values.global_button);
      form_data.append("global_button_link", values.global_button_link);
      form_data.append("global_features", JSON.stringify(newArray));
      dispatch(addHomeDataAction(form_data, setWhoEdit, "add-global-section"));

      setWhoEdit(false);
    }
  };
  return (
    <Formik enableReinitialize initialValues={globaState} validationSchema={gobalSchema} onSubmit={handleGlobalSubmit}>
      {({ values, handleChange, setFieldValue, handleBlur }) => {
        return (
          <Form>
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h6 className={`mb-0 fs-lg ${whoEdit ? "editTitle" : ""}`}>Global Features Section</h6>
                {whoEdit ? (
                  <button type="submit" className="btn btn-primary">
                    <i className="fa-regular fa-floppy-disk"></i> Save
                  </button>
                ) : (
                  <span onClick={() => setWhoEdit(true)} className="btn btn-green">
                    <i className="fa-regular fa-pen-to-square"></i> Edit
                  </span>
                )}
              </Card.Header>
              <Card.Body className="position-relative">
                <div
                  className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${whoEdit ? "d-none" : ""}`}
                  style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
                ></div>
                <Row className="gy-3">
                  <Col xs={12}>
                    <label className="form-label">Header</label>
                    <Field
                      name="global_header"
                      component={TextInput}
                      value={values.global_header}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Header"
                      readOnly={!whoEdit}
                      className={whoEdit ? "editField" : ""}
                    />
                  </Col>
                  <Col xs={12}>
                    <label className="form-label">Header Description</label>
                    <Field
                      name="global_description"
                      component={TextInput}
                      value={values.global_description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Header description"
                      readOnly={!whoEdit}
                      className={whoEdit ? "editField" : ""}
                      multiline
                    />
                  </Col>
                  <Col sm={4}>
                    <label className="form-label">Button</label>
                    <Field
                      name="global_button"
                      component={TextInput}
                      value={values.global_button}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Button"
                      readOnly={!whoEdit}
                      className={whoEdit ? "editField" : ""}
                    />
                    {!values.global_button && values.global_button_link ? <div className="errorMessage">Enter button text</div> : null}
                  </Col>
                  <Col sm={8}>
                    <label className="form-label">Button Link</label>
                    <Field
                      name="global_button_link"
                      component={TextInput}
                      value={values.global_button_link}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Button link"
                      readOnly={!whoEdit}
                      className={whoEdit ? "editField" : ""}
                    />
                    {values.global_button && !values.global_button_link ? <div className="errorMessage">Enter button Link</div> : null}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <FieldArray
              name="global_features"
              render={(arrayHelpers) => (
                <Card className="mt-3 position-relative">
                  <div
                    className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${whoEdit ? "d-none" : ""}`}
                    style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
                  ></div>
                  <Card.Header className="d-flex justify-content-between align-items-center">
                    <h6 className={`mb-0 fs-lg ${whoEdit ? "editTitle" : ""}`}>Features</h6>
                    <Button className="btn btn-primary" size="sm" onClick={() => whoEdit && setShowAddFeature(true)}>
                      <i className="fa-regular fa-plus"></i> Add
                    </Button>
                    {showAddFeature && (
                      <AddFeatureModal
                        show={showAddFeature}
                        setShow={setShowAddFeature}
                        customArrayHelper={arrayHelpers}
                        uploadAction={props.uploadFileAction}
                        uploadNewAction={props.uploadFileNewAction}
                      />
                    )}
                  </Card.Header>
                  {!!values.global_features.length && (
                    <Card.Body>
                      <Table bordered>
                        <tbody>
                          {values.global_features.map((item: any, index: number) => {
                            return (
                              <FeatureItem
                                key={item.title}
                                item={item}
                                index={index}
                                arrayHelpers={arrayHelpers}
                                uploadAction={props.uploadFileAction}
                                setFieldValue={setFieldValue}
                                edit={whoEdit}
                                uploadNewAction={props.uploadFileNewAction}
                              />
                            );
                          })}
                        </tbody>
                      </Table>
                    </Card.Body>
                  )}
                </Card>
              )}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default GlobalFeaturesSection;
